<ion-header class="ion-margin-bottom ion-no-border">
  <ion-toolbar class="ion-no-padding-top-important">
    <ion-buttons slot="start">
      <ion-button color="primary" (click)="cancel()">
        {{'COMPONENTS.MODALS.RETURN' | translate}}
        <ion-icon slot="start" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<app-sub-header-text [title]="'COMPONENTS.MODALS.CONTESTATION' | translate"
  [subtitle]="'COMPONENTS.MODALS.YOUR_DISPUTE_WILL_BE' | translate"></app-sub-header-text>



<ion-content>
  <div height-100 flex-column class="ion-justify-content-between">
    <ion-grid>
      <ion-item sizeXs="12" sizeXl="12" sizeSm="12" sizeMd="12" sizeLg="12" lines="none" color="medium">
        <ion-icon name="information-circle-outline" slot="start" color="white"></ion-icon>
        <ion-text color="white" margin-vertical-half>
          {{'COMPONENTS.MODALS.CHECK_THE_DISPUTE_PERIOD' | translate}}
        </ion-text>
      </ion-item>
      <form [formGroup]="contestationForm">
        <ion-row>
          <ion-col size="12">
            <ion-label color="primary-dark" position="stacked" class="ion-margin-top"> {{'COMPONENTS.MODALS.CONTESTATION' | translate}} </ion-label>
            <ion-textarea formControlName="surveyContestationDescription" class="padding-right-2x" type="text"
              placeholder="{{'COMPONENTS.MODALS.INSERT_THE_DISPUTE' | translate}}" width-100 rows="5">
            </ion-textarea>
            <ion-note *ngIf="surveyContestationDescription.dirty && surveyContestationDescription.errors?.required"
              color="danger">
              {{'COMPONENTS.MODALS.REPORT_THE_DISPUTE' | translate}}
            </ion-note>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
    <footer padding class="ion-text-end" max-width>
      <ion-button class="saveButton" expand="block" color="buttonPrimary" (click)="submit()" responsive-button
        color="buttonPrimary">
        {{'COMPONENTS.MODALS.TO_SAVE' | translate}}
      </ion-button>
    </footer>
  </div>
</ion-content>
